import {CES_RANGE} from './ces-range.model';

/** Ordre d'affichage des étendues dans le paramétrage : de la plus courte à la plus longue. */
export const CES_RANGES: CES_RANGE[] = [CES_RANGE.ONE_TO_FIVE, CES_RANGE.ONE_TO_SEVEN, CES_RANGE.ZERO_TO_TEN];
